import { render, staticRenderFns } from "./WeightedAverage.vue?vue&type=template&id=3019fcb4&scoped=true"
import script from "./WeightedAverage.vue?vue&type=script&lang=js"
export * from "./WeightedAverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019fcb4",
  null
  
)

export default component.exports